import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Main, Container } from './styles';
import Footer from '../Footer';
import Birdseed from '../Birdseed';
import BrowserSupportAlert from '../BrowserSupportAlert';
import { HomeProvider } from '../../contexts/HomeContext';
import LanguageContext from '../../contexts/LanguageContext';
import Header from '../Header';
import HeaderPilot from '../HeaderPilot';
import FooterPilot from '../FooterPilot';

const LayoutComponent = props => {
  const { children } = props;
  const { language } = useContext(LanguageContext);

  return (
    <Container>
      <Switch>
        <HomeProvider path="/login">
          <HeaderPilot language={language} />
          <Main id="main-content">{children}</Main>
          <BrowserSupportAlert />
          <FooterPilot language={language} />
          <Birdseed />
        </HomeProvider>
        <Route>
          <Header language={language} />
          <Main id="main-content">{children}</Main>
          <BrowserSupportAlert />
          <Footer language={language} />
        </Route>
      </Switch>
    </Container>
  );
};

export default LayoutComponent;